import PropTypes from 'prop-types';

import {ASSAY_SCHEMA_SHAPE, AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {DataMissing} from 'results/reduceResults';

import {ASSAY_RESULT_SHAPE, AssayResult} from './AssayRecordConstants';

// Information to handle oversized results, and render AssayResultsTable or AssayGroupResultsTable
export interface ServerResultsTableSpec {
  schemaId: string;
  total: number;
  assayResultIds: Array<string>;
  /**
   * If the table is large, and no results have been loaded.
   *
   * If true, `total` is the total number of results the table would have, if fully loaded.
   */
  isOversized: boolean;
  /**
   * If the table is large, and a limited number of results have been loaded.
   *
   * If true, `total` is the actual number of results that have been loaded.
   */
  isTruncated?: boolean;
}

// Same as ServerResultsTableSpec, but IDs adapted to objects and handlers
export interface ResultsTableSpec {
  schema: AssaySchema;
  total: number;
  assayResults: Array<AssayResult | DataMissing>;
  isOversized: boolean;
  isTruncated?: boolean;
  onDownloadAsCSV: () => void;
}

export const RESULTS_TABLE_SPEC_SHAPE = PropTypes.shape({
  schema: ASSAY_SCHEMA_SHAPE.isRequired,
  total: PropTypes.number.isRequired,
  assayResults: PropTypes.arrayOf(ASSAY_RESULT_SHAPE.isRequired).isRequired,
  isOversized: PropTypes.bool.isRequired,
  isTruncated: PropTypes.bool,
  onDownloadAsCSV: PropTypes.func,
});
